import * as React from 'react'
import moment from 'moment'
import { BlazeButton } from '../../../../components/CustomButtons/BlazeButton'
import { ComplianceStore } from './ComplianceStore'
import { monthType } from '../../../../components/Input/MonthSelector'
import { monthStringWithLeadingZero } from '../../../../utilities/monthStringWithLeadingZero'
import { observer } from 'mobx-react'
import { MonthSelector } from '../../../../components/Input'
import { Select } from 'antd-v4'

interface Props {
  complianceStore: ComplianceStore
  onClickNext: () => void
  setMonthAndYear: (month: monthType, year: number) => void
  getYearsUntilNow: (startYear?: number) => { value: number; label: string }[]
}

interface State {
  isCustomSelected: boolean
}

@observer
export class ComplianceMonthSelector extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isCustomSelected: false,
    }
  }

  render() {
    const { isCustomSelected } = this.state
    const { complianceStore } = this.props

    const currentMonth = (moment().month() + 1) as monthType
    const currentYear = moment().year()
    const previousMonth = (moment().subtract(1, 'month').month() + 1) as monthType
    const previousYear = moment().subtract(1, 'month').year()

    const yearsSelection = this.props.getYearsUntilNow()
    const preDefinedOptions = [
      {
        month: previousMonth,
        year: previousYear,
        title: 'Last month',
        description: 'You must report for the previous month when submitting.',
      },
      {
        month: currentMonth,
        year: currentYear,
        title: 'This month',
        description: 'Monitor your current compliance status.',
      },
    ]

    return (
      <div>
        {complianceStore.locationIds.length > 0 ? (
          <>
            <div className='mb-4 mt-4'>
              <h5>Select Month</h5>
              <div className='text-muted'>
                On the first week of every month, retailers are required to submit reports for the
                previous month.
              </div>
              <div className='text-muted'>
                If you want to view your current compliance, generate for your current month.
              </div>
            </div>

            {preDefinedOptions.map(({ title, month, year }) => (
              <div className='' key={title} style={{ width: 300 }}>
                <button
                  className='btn btn-light mb-2 w-100 p-4 text-left'
                  onClick={() => this.props.setMonthAndYear(month, year)}
                >
                  <div className='d-flex'>
                    <div style={{ flexGrow: 1 }}>
                      <div>{title}</div>
                      <h3>
                        {moment(`${year}-${monthStringWithLeadingZero(month)}-01`).format(
                          'MMMM YYYY',
                        )}
                      </h3>
                    </div>
                    <div>
                      <span className='fa fa-angle-right fa-2x ml-4 mt-4 text-muted' />
                    </div>
                  </div>
                </button>
              </div>
            ))}
            <div>
              <button
                className='btn btn-light p-4 text-left'
                onClick={() => this.setState({ isCustomSelected: !isCustomSelected })}
                style={{ width: 300 }}
              >
                <div className='d-flex'>
                  <div style={{ flexGrow: 1 }}>
                    <div>Custom date</div>
                  </div>
                  <div>
                    <span
                      className={`fa fa-angle-${isCustomSelected ? 'up' : 'right'} ml-4 text-muted`}
                    />
                  </div>
                </div>
              </button>
            </div>
            {isCustomSelected && (
              <>
                <div className='mt-4' style={{ width: 300 }}>
                  <MonthSelector
                    month={complianceStore.month}
                    onChange={(newMonth) => complianceStore.changeMonth(newMonth)}
                    isLabel={false}
                  />
                  <Select
                    className='w-100'
                    showSearch
                    value={complianceStore.year}
                    placeholder='Year'
                    options={yearsSelection}
                    onChange={(value) => {
                      complianceStore.changeYear(value)
                    }}
                  />
                  <BlazeButton
                    buttonProps={{
                      className: 'w-100 mt-3',
                      type: 'primary',
                      size: 'large',
                      onClick: this.props.onClickNext,
                    }}
                    titleProps={{
                      title: 'Select date',
                    }}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <div className='text-muted'>Please select a location above</div>
        )}
      </div>
    )
  }
}
